module.exports = __webpack_public_path__ + "static/media/retirement.9937121b.webp";